import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import Image from 'next/image';
import { DOWNLOAD_APP_LINKS } from '@/shared/constants/links-constants';
import styles from './app-download.module.scss';
export default function AppDownload() {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <a className={styles.link} href={DOWNLOAD_APP_LINKS.appStore} rel="noreferrer"><Image src="/images/services/applestore.svg" alt="apple store" width={25} height={25} /></a>;
    t1 = cx(styles.link, styles.google_icon);
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={styles.container}>{t0}<a className={t1} href={DOWNLOAD_APP_LINKS.googlePlay} rel="noreferrer" target="_blank"><Image src="/images/services/playmarket.svg" alt="apple store" width={25} height={25} /></a></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}